// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"2b96ece2","536":"8c8340b1"}[chunkId] + ".chunk.js";
};